export default "__VITE_ASSET__PmFQMpK3__"